const updates = [
  { date: '2026-08-01', title: '《雷霆行动》高清版上线 — 年度动作巨制，全程无尿点', tag: '新片上线' },
  { date: '2026-07-30', title: '喜剧片《欢乐一家人》续集独家首播，爆笑回归', tag: '独家首播' },
  { date: '2026-07-28', title: '经典修复版《霸王别姬》4K 重制画质全面升级', tag: '经典修复' },
  { date: '2026-07-25', title: '科幻频道新增《星际迷航》全系列中文字幕版', tag: '剧集更新' },
  { date: '2026-07-22', title: '动画专区引进宫崎骏经典作品高清数字修复版', tag: '专区上新' },
  { date: '2026-07-20', title: '纪录片频道新增 BBC 自然系列全季完整上线', tag: '内容扩充' },
  { date: '2026-07-18', title: '悬疑片《第七重真相》观影人数突破百万大关', tag: '热门排行' },
  { date: '2026-07-15', title: '暑期档特别策划：百部经典电影限时免费看', tag: '限时活动' },
  { date: '2026-07-12', title: '播放器全面升级，新增记忆续播与画质自适应功能', tag: '功能更新' },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="w-full py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">
            最新快讯
          </h2>
          <p className="mt-3 text-sm text-foreground-600 max-w-xl mx-auto">
            电影片源每日更新，精彩内容第一时间送达
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="relative pl-8 md:pl-10 border-l-2 border-background-300">
            {updates.map((item, i) => (
              <div
                key={i}
                className={`relative pb-8 md:pb-10 last:pb-0 ${
                  i === 0 ? 'border-accent-400' : ''
                }`}
              >
                <span className="absolute -left-[21px] md:-left-[25px] top-0 w-3.5 h-3.5 rounded-full bg-accent-500 border-2 border-background-100"></span>
                <span className="inline-block px-2 py-0.5 bg-accent-100 text-accent-700 text-xs font-medium rounded mb-2 whitespace-nowrap">
                  {item.tag}
                </span>
                <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-900">
                  {item.title}
                </h3>
                <time className="block mt-1 text-xs text-foreground-500">{item.date}</time>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}